<script setup lang="ts">
/*
  "A new version of Notitia is available", pinned to the bottom of the window, with Reload.

  In `shared/` and mounted once by `App.vue`: the Designer, the Operator and the control center all
  need it, and a section may not host something for the other two. It is drawn only once the service
  worker has a new version waiting (`utils/serviceWorker.ts`), so a browser without a worker, a
  visitor who has not signed in and a window that is up to date never see it.

  Reload is the person's answer, not the app's: a window never changes version under somebody who is
  in the middle of something. Dismissing hides the prompt for this page load; the version is still
  waiting, and the next load asks again.
*/
import { ref } from "vue";
import { mdiUpdate } from "@mdi/js";
import { HabBanner, HabButton } from "@livereader/habitus-vue";
import { applyUpdate, updateAvailable } from "@/shared/utils/serviceWorker";

const dismissed = ref(false);
</script>

<template>
	<div
		v-if="updateAvailable && !dismissed"
		class="pointer-events-none fixed inset-x-0 bottom-4 z-(--hab-z-toast) flex justify-center px-4"
	>
		<HabBanner
			class="shadow-elev-4 pointer-events-auto w-full max-w-xl"
			tone="info"
			:icon="mdiUpdate"
			:title="$t('pwa.update.available')"
			:dismiss-label="$t('pwa.update.dismiss')"
			@dismiss="dismissed = true"
		>
			<template #action>
				<HabButton
					variant="text"
					@click="applyUpdate"
				>
					{{ $t("pwa.update.reload") }}
				</HabButton>
			</template>
		</HabBanner>
	</div>
</template>
